"use client";

import React from "react";
import { Button, Timeline } from "flowbite-react";
import { HiCalendar, HiDownload } from "react-icons/hi";
import { timeline_data } from "./data";

function TimelineNotebook() {
  return (
    <Timeline>
      {
        // @ts-ignore
        timeline_data.map((elt: any, idx: number) => {
          return (
            <Timeline.Item key={idx}>
              <Timeline.Point
                // @ts-ignore
                icon={HiCalendar}
              />
              <Timeline.Content>
                <Timeline.Time>{elt.startDate}</Timeline.Time>
                <Timeline.Title className="!pb-5">
                  {"Week " + elt.week}
                </Timeline.Title>
                <Timeline.Body>
                  <ul className="list-disc flex flex-col">
                    {!Array.isArray(elt.description)
                      ? elt.descriptio
                      : elt.description.map((content: any, idx: number) => {
                          return (
                            <ol className="list-disc list-outside pb-4">
                              <p className="font-bold">{content.subtitle}</p>
                              {content.lines.map((line: any, idx: number) => (
                                <li className="list-[square] ml-10 ">{line}</li>
                              ))}
                              <p
                                className={`${
                                  content.lines.length === 0 ? "" : "pb-5"
                                }`}
                              ></p>
                            </ol>
                          );
                        })}
                  </ul>
                </Timeline.Body>
                <Button color="gray">
                  <a href={elt.link}>Download</a>
                  <HiDownload className="ml-2 w-3 h-3" />
                </Button>
              </Timeline.Content>
            </Timeline.Item>
          );
        })
      }
    </Timeline>
  );
}

export default TimelineNotebook;
